import React from 'react';
import {
	Edit,
	TextInput,
	SelectInput,
	ArrayInput,
	SimpleFormIterator,
	BooleanInput,
	TabbedForm,
	FormTab,
	required,
	email
} from 'react-admin';
import { EditTitle } from 'components/AppBar/Titles';
import { EditToolbar } from 'components/Toolbar/EditToolbar';

export const AccountsEdit = (props) => (
  	<Edit title={<EditTitle source='email' />} {...props}>
		<TabbedForm variant='standard' margin='normal' toolbar={<EditToolbar />}>
			<FormTab label='Personal Details'>
				<TextInput
					source='first_name'
					label='First Name'
					validate={required()}
					fullWidth
				/>
				<TextInput
					source='last_name'
					label='Last Name'
					validate={required()}
					fullWidth
				/>
				<TextInput
					source='email'
					label='Email'
					validate={[email(), required()]}
					disabled
					fullWidth
				/>
				<BooleanInput source='email_notifications_on' label='Email Notifications?' fullWidth />
			</FormTab>

			<FormTab label='Credentials'>
				<ArrayInput label='' source='credentials'>
					<SimpleFormIterator disableRemove disableReordering>
						<TextInput
							label='Email'
							source='sid'
							validate={[email(), required()]}
							fullWidth
						/>
						<TextInput
							label='Password'
							type='password'
							source='secret'
							fullWidth
						/>
						<SelectInput
							label='Status'
							source='status'
							validate={required()}
							fullWidth
							choices={[
								{ id: 'pending', name: 'Pending Confirmation' },
								{ id: 'active', name: 'Active' },
								{ id: 'locked', name: 'Locked' },
								{ id: 'suspended', name: 'Suspended' },
							]}
						/>
					</SimpleFormIterator>
				</ArrayInput>
			</FormTab>
		</TabbedForm>
  	</Edit>
);